<template>
  <v-chip
    v-if="max"
    :color="getStatusColor(status.name)"
    text-color="white"
    style="width: 100%; max-width: 150px"
    label
  >
    {{ status.text }}
  </v-chip>
  <v-chip
    v-else
    :color="getStatusColor(status.name)"
    text-color="white"
    style="max-width: 150px"
    label
  >
    {{ status.text }}
  </v-chip>
</template>

<script>
export default {
  name: 'DaktelaActivityStatus',
  props: {
    status: {
      type: Object,
      required: true,
    },
    max: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getStatusColor(status) {
      let color = '#2281C9'

      switch (status) {
        case 'OK':
          color = '#9ccc65'
          break

        case 'WAIT':
          color = '#ffc107'
          break

        case 'DRAFT':
          color = '#2281C9'
          break

        case 'SENT':
          color = '#2281C9'
          break

        case 'MISSED':
          color = '#ef5350'
          break

        case 'MISSED_WITH_CALLBACK':
          color = '#ef5350'
          break

        case 'FAILED':
          color = '#ef5350'
          break

        case 'NONE':
          color = '#fff'
          break

        default:
          color = '#2281C9'
      }

      return color
    },
  },
}
</script>
